import React, { Component } from "react";
import { connect } from "react-redux";
import MajorSearch from "./components/MajorSearch";
import MajorKeySearch from "./components/MajorKeySearch";
import HotMajor from "./components/HotMajor";
import { actions as toCollegeToolActions } from "../../../redux/modules/tocollagetool";
import { post, get } from "../../../utils/request";
import { jumpUrl } from "../../../utils/tool.js";
import "./style.css";
class ToCollegeToolMajor extends Component {
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    this.requestUserMajorCondition();
    this.requestIsBuy();
    this.handleReturnTop();
    document.title = "浙考之家-每日高升-志愿智能助手";
  }
  render() {
    const { searchVisible, majorCondition } = this.props;
    return (
      <div>
        <MajorSearch
          handleVisibleSearch={this.handleVisibleSearch}
          visible={searchVisible}
          placeholder="请输入想学习的专业"
        ></MajorSearch>
        <MajorKeySearch
          handleVisibleSearch={this.handleVisibleSearch}
          handleAddMajor={this.handleAddMajor}
          visible={!searchVisible}
          placeholder="请输入想学习的专业"
          majorCondition={majorCondition}
        ></MajorKeySearch>
        <div style={{ height: 40 }}></div>
        <div
          className={
            searchVisible === true
              ? "to_collage_major_item_box"
              : "to_collage_major_item_box display_none"
          }
        >
          <div>
            已选专业<span>{majorCondition.length}</span>个
            {majorCondition.length>= 0 ? (
              <span>（<span>顶部输入</span>或<span>下方选择</span>均可）</span>
            ) : (
              ""
            )}
          </div>
          <div className="major_top_15">
            {majorCondition.map((item, index) => {
              return (
                <div key={index} className="to_collage_major_item">
                  <div className="to_collage_major_content">{item}</div>
                  <img
                    onClick={() => this.handleRemoveMajor(item)}
                    alt=""
                    src={require("../../../images/tocollege/close.png")}
                  ></img>
                </div>
              );
            })}
          </div>
        </div>
        <div className="clear"></div>
        <div
          className={
            majorCondition.length === 0
              ? " to_collage_major_btn_box display_none"
              : "to_collage_major_btn_box"
          }
          onClick={() => this.handleConfirm()}
        >
          确定
        </div>
        <img
          className="hot_major_img"
          alt=""
          src={require("../../../images/tocollege/hot-major.png")}
        ></img>
        <HotMajor handleAddHotMajor={this.handleAddHotMajor}></HotMajor>
      </div>
    );
  }
  /**
   * 获取用户是否购买的标识
   */
  requestIsBuy = () => {
    get("/public/v1/user/isBuy").then((res) => {
      if (res.data === false) {
        jumpUrl("pay");
      }
    });
  };
  /**
   * 控制搜索框显示和关闭
   */
  handleVisibleSearch = () => {
    const { dispatch } = this.props;
    let searchVisible = this.props.searchVisible;
    dispatch(toCollegeToolActions.setSearchVisible(!searchVisible));
  };
  /**
   * 添加专业
   */
  handleAddMajor = (major) => {
    const { dispatch } = this.props;
    let majorCondition = this.props.majorCondition;
    majorCondition.push(major);
    majorCondition = Array.from(new Set(majorCondition));
    dispatch(toCollegeToolActions.setMajorCondition(majorCondition));
    this.handleVisibleSearch();
  };

  /**
   * 添加热门专业
   */
  handleAddHotMajor = (major) => {
    const { dispatch } = this.props;
    let majorCondition = this.props.majorCondition;
    majorCondition.push(major);
    majorCondition = Array.from(new Set(majorCondition));
    dispatch(toCollegeToolActions.setMajorCondition(majorCondition));
  };
  /**
   * 移除专业
   */
  handleRemoveMajor = (major) => {
    const { dispatch } = this.props;
    let majorCondition = this.props.majorCondition;
    majorCondition.splice(
      majorCondition.findIndex((item) => item === major),
      1
    );
    majorCondition = Array.from(new Set(majorCondition));
    dispatch(toCollegeToolActions.setMajorCondition(majorCondition));
  };

  /**
   * 将文章列表返回顶部
   */
  handleReturnTop = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  };

  /**
   * 确认专业
   */
  handleConfirm = () => {
    let params = {
      majorCondition: this.props.majorCondition,
    };
    post("/public/v1/toCollage/major/condition", params).then((res) => {
      this.props.history.push("/tocollege/filter");
    });
  };

  /**
   * 请求用户专业条件
   */
  requestUserMajorCondition = () => {
    const { dispatch } = this.props;
    get("/public/v1/toCollage/user/majors").then((res) => {
      let majorCondition = JSON.parse(JSON.stringify(res.data));
      dispatch(toCollegeToolActions.setMajorCondition(majorCondition));
    });
  };
}
const mapStateToProps = (state) => {
  return {
    majorCondition: state.toCollageTool.toCollageData.majorCondition,
    searchVisible: state.toCollageTool.toCollageUIData.searchVisible,
  };
};
export default connect(mapStateToProps)(ToCollegeToolMajor);



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollegeToolMajor/index.js